/**
 * Merge a keyed reducer map into redux-form values.
 *
 * Used for tickettype `pricings`, and the same keepDirtyOnReinitialize pattern
 * for `opaque.emails` / `opaque.layouts.overrides` / `rules.stocks.overrides`.
 *
 * With `keepDirtyOnReinitialize`, newly added nested keys from initialValues are
 * not merged into the form — the UI renders from the reducer while Fields bind
 * to missing form paths (empty money inputs, broken id autofill).
 *
 * Keep dirty form rows for keys that already exist; add missing reducer keys;
 * drop keys removed from the reducer. Optional `renamed` moves a form row.
 */
export function merge_pricings_for_form_sync(form_pricings, reducer_pricings, renamed) {
    const merged = { ...(form_pricings || {}) };
    const from_reducer = reducer_pricings || {};

    if (renamed?.oldId && renamed?.newId && renamed.oldId !== renamed.newId) {
        const moved = merged[renamed.oldId];
        delete merged[renamed.oldId];
        if (moved !== undefined || from_reducer[renamed.newId]) {
            merged[renamed.newId] = {
                ...(from_reducer[renamed.newId] || {}),
                ...(moved || {}),
            };
        }
    }

    Object.keys(from_reducer).forEach((key) => {
        if (!(key in merged))
            merged[key] = from_reducer[key];
    });

    Object.keys(merged).forEach((key) => {
        if (!(key in from_reducer))
            delete merged[key];
    });

    return merged;
}
